import {Pagination} from '@app/core/models/pagination.model';
import {Availability} from '@app/core/models/availability.model';

export interface IAvailabilitiesState {
	approvedPagination: Pagination;

	availabilities: Availability[];
	approvedAvailabilities: Availability[];

	isLoading: boolean;
	isLoadingApprovedAvailabilities: boolean;
}

export const initialAvailabilitiesState: IAvailabilitiesState = {
	approvedPagination: undefined,

	availabilities: [],
	approvedAvailabilities: [],

	isLoading: false,
	isLoadingApprovedAvailabilities: false,
};
